import { Bot } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTheme } from '../../../contexts/ThemeContext';

export const TypingIndicator = ({ inline = false }) => {
  const { isDark } = useTheme();

  if (inline) {
    return (
      <span className="inline-flex gap-1 ml-1" data-testid="typing-indicator-inline">
        {[0, 0.15, 0.3].map((delay, i) => (
          <span
            key={i}
            className={`w-1 h-1 rounded-full animate-bounce ${isDark ? 'bg-neutral-400' : 'bg-neutral-500'}`}
            style={{ animationDelay: `${delay}s` }}
          />
        ))}
      </span>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15 }}
      className="flex items-start gap-2.5 justify-start"
      data-testid="ai-typing-indicator"
    >
      <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center ${
        isDark ? 'bg-neutral-800 text-neutral-400' : 'bg-neutral-100 text-neutral-500'
      }`}>
        <Bot className="w-3.5 h-3.5" />
      </div>
      <div className={`rounded-lg px-3 py-2 ${
        isDark ? 'bg-neutral-800' : 'bg-neutral-100'
      }`}>
        <span className="inline-flex gap-1">
          {[0, 0.15, 0.3].map((delay, i) => (
            <span
              key={i}
              className={`w-1.5 h-1.5 rounded-full animate-bounce ${
                isDark ? 'bg-neutral-500' : 'bg-neutral-400'
              }`}
              style={{ animationDelay: `${delay}s` }}
            />
          ))}
        </span>
      </div>
    </motion.div>
  );
}; 